<template>
  <div id="mete-history" style=" overflow:hidden;">
    <div v-if="meteLoadFlg" style="left: 40%; top: 30%; position:absolute; color: #5BF2FF">
      <dv-loading>Loading....</dv-loading>
    </div>
    <div class="meteHistory-data">
      <div class="meteHistory-data-head">
        <div class="meteHistory-head-title">
          <span class="meteHistory-title-container" >气象历史数据</span>
        </div>

        <div class="meteHistory-head-select">
          <div class="meteHistory-select-device">
            <el-select @change="meteHistoryChange($event)" v-model="defaultMeteDevice" filterable :disabled="meteLoadFlg">
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in meteHistoryList" >
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>

          <div class="meteHistory-select-attribute">
            <el-select @change="meteAttrChange($event)" v-model="defaultMeteAttr" filterable :disabled="meteLoadFlg">
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in meteAttrList" >
              </el-option>
            </el-select>
          </div>

          <div class="meteHistory-select-time">
            <el-date-picker  @change="meteSelectTime"  v-model="defaultMeteTime" unlink-panels type="datetimerange" :picker-options="metePickerOptions" align="right" :disabled="meteLoadFlg"
                             end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="meteHistory-select-agg">
            <el-dropdown @command="meteSelectAgg" :disabled="meteLoadFlg">
              <span class="el-dropdown-link">
                {{meteAggValue}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">最大值</el-dropdown-item>
                <el-dropdown-item command="2">最小值</el-dropdown-item>
                <el-dropdown-item command="3">平均值</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="meteHistory-head-btn">
          <div class="meteHistory-head-btnContainer">
            <el-button type="primary" @click="meteQueryData()" :disabled="meteLoadFlg">查询</el-button>
            <el-button type="warning" @click="meteExportData()" :disabled="meteLoadFlg">导出</el-button>
            <el-button type="danger" @click="meteChangeChart()" :disabled="meteLoadFlg">{{meteChartName}}</el-button>
          </div>
        </div>
      </div>
      <div class="meteHistory-data-content">
        <div class="meteHistory-content-table" v-show="meteChartNum == 1 ? true : false">
<!--          <el-table :data="meteTableData" border >-->
<!--            <el-table-column prop="ts" label="日期" style="width: 40%">-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="name" label="名称" style="width: 30%">-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="value" label="值" style="width: 30%">-->
<!--            </el-table-column>-->
<!--          </el-table>-->
          <el-table :data="meteTableData.slice((meteCurrentPage-1)*metePageSize,meteCurrentPage*metePageSize)" border>
            <el-table-column prop="ts" label="日期" style="width: 40%">
            </el-table-column>
            <el-table-column prop="name" label="名称" style="width: 30%">
            </el-table-column>
            <el-table-column prop="value" label="值" style="width: 30%">
            </el-table-column>
          </el-table>

          <el-pagination @size-change="meteSizeChange" @current-change="meteCurrentChange" :current-page="meteCurrentPage" style="text-align: center; margin-top: 0.3%"
                         :page-sizes="[15, 30, 50, 100]"  :page-size="metePageSize" layout="total, sizes, prev, pager, next, jumper" :total="meteTableData.length">
          </el-pagination>
        </div>

        <div class="meteHistory-content-chart" v-show="meteChartNum ==2 ? true : false">
          <div class="meteProCharts" id="meteChart">
            <img src="../img/bg1.png" v-if="!meteShow">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {getTimeDeviceHistory} from "../../until/api/MeteSoil";
  export default {
    name: 'MeteHistoryData',
    components: {},
    data() {
      return {
        meteDeviceList: [],
        meteHistoryList: [],
        defaultMeteDevice: '',
        meteAttrList: [],
        defaultMeteAttr: '',
        defaultMeteTime: [moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")],
        metePickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        startTime: '',
        endTime: '',
        meteAggSelect: '1',
        meteAggValue: '最大值',
        meteAgg:'',
        meteInterval: 0,
        meteChartNum: 1,
        meteChartName: '折线图',
        meteDeviceId: {},
        meteTableData: [],
        meteTimeValue: [],
        meteDataValue: [],
        meteShow: false,
        meteOption: {},
        meteCurrentPage: 1,
        metePageSize: 15,
        //meteErrorNum: 0,
        meteLoadFlg: false,
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {//获取用户等级
        that.meteHistoryDeviceBoards(deviceList);//获取设备列表
      })
    },

    methods: {
      /**
       * 获取设备列表
       * @param response
       */
      meteHistoryDeviceBoards(response) {
        // this.meteDeviceList = [];
        // if(response.data.length === 0)  return;
        // for(let i = 0; i < response.data.length; i++) {
        //   let meteJson = {};
        //   meteJson.id = response.data[i].id.id;
        //   meteJson.name = response.data[i].name;
        //   meteJson.type = response.data[i].id.entityType;
        //   this.meteDeviceList.push(meteJson)
        // }
        // if(this.meteDeviceList.length > 0) {
        //   this.defaultMeteDevice = this.meteDeviceList[0].id;
        //   this.meteHistoryAttr();//获取设备属性
        // }
        this.meteDeviceList = [];
        if(response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let meteJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          };

          let promise = this.$MeteSoilCommon.getLastConnectTime(meteJson.type, meteJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            meteJson.state = time < beforeTime ? 'red' : 'green';
            return meteJson;
          });

          promises.push(promise);
        }

        Promise.all(promises).then(results => {
          this.meteDeviceList = results;
          if(this.meteDeviceList.length > 0) {
            this.meteHistoryDevice(0, this.meteDeviceList.length);
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      meteHistoryDevice(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.meteDeviceList[j].id, function (deviceInfo) {
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.meteKeyOperate(j, keyData);
            if(++j < length) {
              that.meteHistoryDevice(j, length);
            }
          })
        })
      },

      meteKeyOperate(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        //筛选非墒情属性
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('soil') < 0  && keyList[i].indexOf('fxd_') < 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }

        if(strKey != '') {
          this.meteHistoryList.push(this.meteDeviceList[j]);

          if(this.defaultMeteDevice == '') {
            this.defaultMeteDevice = this.meteHistoryList[0].id;
            this.meteHistoryAttr();//获取设备属性
          }
        }
      },

      /**
       * 切换设备
       * @param event
       */
      meteHistoryChange(event) {
        this.defaultMeteDevice = event;
        this.setEmptyMeteOption();//清空折线图
        this.meteTableData = [];
        this.meteTimeValue = [];
        this.meteDataValue = [];
        this.meteHistoryAttr();//获取设备属性
      },

      /**
       * 获取设备属性
       */
      meteHistoryAttr() {
        this.meteAttrList = [];
        this.defaultMeteAttr = '';
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.defaultMeteDevice, function (deviceInfo) {//获取设备id
          that.meteDeviceId = deviceInfo;
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {//获取key
            let keyList = keyData.split(',');
            for(let i = 0; i < keyList.length; i++) {
              if(keyList[i].indexOf('soil') < 0 && keyList[i].indexOf('fxd_') < 0) {//筛选出非墒情属性
                let keyJson = {};
                keyJson.id = keyList[i];
                keyJson.name = that.$t(keyList[i]).split(',')[0];
                that.meteAttrList.push(keyJson);
              }
            }
            that.meteAttrList.length == '' ? that.defaultMeteAttr = '' : that.defaultMeteAttr = that.meteAttrList[0].id;
          })
        });
      },

      /**
       * 切换属性
       * @param event
       */
      meteAttrChange(event) {
        this.defaultMeteAttr = event;
        this.setEmptyMeteOption();//清空折线图
        this.meteTableData = [];
        this.meteTimeValue = [];
        this.meteDataValue = [];
      },

      /**
       * 获取时间戳
       * @param val
       */
      meteSelectTime(val) {
        if(val === null) {
          this.defaultMeteTime = [moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")];
          this.startTime = '';
          this.endTime = '';
        } else {
          this.startTime = new Date(val[0]).getTime();
          this.endTime = new Date(val[1]).getTime();
        }
      },

      /**
       * 切换聚合函数
       * @param event
       */
      meteSelectAgg(event){
        switch (event) {
          case "1":
            this.meteAggSelect = "1";
            this.meteAggValue = "最大值";
            break;
          case "2":
            this.meteAggSelect = "2";
            this.meteAggValue = "最小值";
            break;
          case "3":
            this.meteAggSelect = "3";
            this.meteAggValue = "平均值";
            break;
        }
      },

      /**
       * 查询历史数据
       */
      meteQueryData() {
        if(this.defaultMeteAttr == '') return;
        this.meteTableData = [];
        this.meteTimeValue = [];
        this.meteDataValue = [];
        this.meteCurrentPage = 1;
        this.setEmptyMeteOption();
        if(this.startTime === '' || this.endTime == '') return;
        let time = this.endTime - this.startTime;
        this.meteLoadFlg = true;
        //设置聚合时间间隔以及聚合函数
        if(time <= 1000 * 60 * 60 * 24) {
          this.meteAgg = 'NONE';
          this.meteInterval = 0;
        } else {
          switch (this.meteAggSelect) {
            case "1":
              this.meteAgg = 'MAX';
              this.getMeteInterval();//设置聚合时间间隔
              break;
            case "2":
              this.meteAgg = 'MIN';
              this.getMeteInterval();//设置聚合时间间隔
              break;
            case "3":
              this.meteAgg = 'AVG';
              this.getMeteInterval();//设置聚合时间间隔
              break;
          }
        }
        this.getMeteHistory();//获取历史数据
      },

      /**
       * 设置聚合时间间隔
       */
      getMeteInterval() {
        let intervalTime = (this.endTime - this.startTime) / (1000 * 60 * 60 * 24);
        if(intervalTime > 1 && intervalTime < 30) {// 1天到30天 小于一个月设置时间间隔
          switch (true) {
            case intervalTime > 1 && intervalTime <= 3: //大于1天小于等于3天
              this.meteInterval = 1000 * 60 * 10;
              break;
            case intervalTime > 3 && intervalTime <= 5: //大于3天小于等于5天
              this.meteInterval = 1000 * 60 * 15;
              break;
            case intervalTime > 5 && intervalTime <= 10: //大于5天小于等于10天
              this.meteInterval = 1000 * 60 * 30;
              break;
            case intervalTime > 10 && intervalTime <= 20: //大于10天小于等于20天
              this.meteInterval = 1000 * 60 * 60;
              break;
            case intervalTime > 20://大于20天
              this.meteInterval = 1000 * 60 * 60 * 2;
              break;
          }
        } else if(intervalTime >=30) {// 30天以上 大于一个月设置时间间隔
          switch (true) {
            case intervalTime === 30: //等于30天
              this.meteInterval = 1000 * 60 * 60 * 2;
              break;
            case intervalTime > 30 && intervalTime <= 90: //大于1个月小于等于3个月
              this.meteInterval = 1000 * 60 * 60 * 5;
              break;
            case intervalTime > 90 && intervalTime <= 180: //大于3个月小于等于6个月
              this.meteInterval = 1000 * 60 * 60 * 10;
              break;
            case intervalTime > 180 && intervalTime <= 240: //大于6个月小于等于8个月
              this.meteInterval = 1000 * 60 * 60 * 12;
              break;
            case intervalTime > 240://大于8个月
              this.meteInterval = 1000 * 60 * 60 * 24;
              break;
          }
        }
      },

      /**
       * 数字表与折线图切换
       */
      meteChangeChart() {
        if (this.meteChartNum == 1) {//切换折线图
          this.meteChartNum = 2;
          this.meteChartName = '数字表';
          if(this.meteDataValue.length == 0) {
            this.setEmptyMeteOption();
          } else {
            this.$nextTick(() => {
              this.setMeteOption();
            })
          }
        } else {//切换数字表
          this.meteChartNum = 1;
          this.meteChartName = '折线图';//折线图
        }
      },

      /**
       * 获取历史数据
       */
      getMeteHistory() {
        //this.meteErrorNum++;
        getTimeDeviceHistory(this.meteDeviceId.entityType, this.meteDeviceId.id, this.defaultMeteAttr, this.startTime, this.endTime, this.meteInterval, this.meteAgg).then(response => {
          //this.meteErrorNum = 0;
          if (JSON.stringify(response.data) == "{}") {
            //未查询到数据
            this.meteLoadFlg = false;
            return;
          }
          for(let obj in response.data) {
            for (let i = 0; i < response.data[obj].length; i++) {
              let tableJson = {};
              tableJson.ts = this.$commonFun.dateFormat(response.data[obj][i].ts);
              tableJson.name = this.$t(this.defaultMeteAttr).split(',')[0];
              let unit = this.$t(this.defaultMeteAttr).split(',')[1] === undefined ? '' : this.$t(this.defaultMeteAttr).split(',')[1];
              tableJson.value = parseFloat(response.data[obj][i].value).toFixed(2)  + unit;
              this.meteTimeValue.push(this.$commonFun.dateFormat(response.data[obj][i].ts));
              this.meteDataValue.push( parseFloat(response.data[obj][i].value).toFixed(2));
              this.meteTableData.push(tableJson);
            }
          }
          this.$nextTick(() => {
            this.setMeteOption();//折线图
          });
          this.meteLoadFlg = false;
        }).catch(error => {
          // if(this.meteErrorNum > 4) {
          //   this.meteErrorNum = 0;
          //   console.log("error", error);
          //   this.meteLoadFlg = false;
          // } else {
          //   this.getMeteHistory();
          // }
          console.log("error", error);
          this.meteLoadFlg = false;
        })
      },

      /**
       * 切换条数
       * @param size
       */
      meteSizeChange(size) {
        this.metePageSize = size;
      },

      /**
       * 切换页数
       * @param currentPage
       */
      meteCurrentChange(currentPage) {
        this.meteCurrentPage = currentPage;
      },

      /**
       * 折线图
       */
      setMeteOption() {
        let unit = this.$t(this.defaultMeteAttr).split(',')[1] === undefined ? '': '(' + this.$t(this.defaultMeteAttr).split(',')[1] + ')';
        this.meteOption = {
          color: ['#FEC00A',],
          title: {
            text: this.$t(this.defaultMeteAttr).split(',')[0],
            left: 'center', //居中
            textStyle: {
              color: '#ffffff',
              fontSize: 22,
              lineHeight: 35,
              fontWeight: 'normal'
            }

          },
          tooltip: { //提示框
            trigger: 'axis',
            backgroundColor: "rgba(128, 128, 128, 0.5)",
            borderWidth: 1, //边框宽度设置1
            borderColor: "rgba(49, 73, 99, 1)", //设置边框颜色
            borderRadius: 4,
            padding: 5,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '1%',
            right: '5%',
            bottom: '5%',
            top:'10%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            name: '时间',
            type: 'category', //坐标轴类型。
            nameTextStyle:{
              color:'#fff',
              fontSize :14//字体大小
            },
            boundaryGap: true, //坐标轴两边留白策略
            data: this.meteTimeValue,
            offset: 8,
            axisLabel: {//坐标轴刻度标签的相关设置
              // rotate: 30,
              interval: 'auto',
              rotate: -50,
              show: true,
              textStyle: {
                color: '#fff',
                fontSize :12//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            }
          },
          yAxis: {
            name: '数值' + unit,
            type: 'value',
            nameTextStyle:{
              color:'#fff',
              fontSize :14//字体大小
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff', //文字的颜色
                fontSize :16//字体大小
              },
            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data: this.meteDataValue,
              symbolSize: 10,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                color:'#FEC00A'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
          ],
          dataZoom: [
            {
              endValue: 15, //一次显示10个
              type: 'slider',//有滑动条
              show: true,//是否显示滑动条
              xAxisIndex: [0],//开始下标
              handleSize: 0,//滑动条的左右2个滑动条大小
              height: 20, //滑动条高度
              left: "0%",//左边距离
              right: "0%",//右边距离
              bottom: 0,//底部距离
              // borderColor: "#3a4650", //边框颜色
              borderColor: "#101f3e", //边框颜色
              fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
              borderRadius: 5,//边框弧度
              //backgroundColor: "#1c2735",//未选区域中的背景色
              backgroundColor:'#0b2d4c',
              showDataShadow: false, //是否显示数据阴影
              showDetail:false,//拖动时是否显示数值
              realtime: true,// 是否实时更新
              filterMode: "filter",
            },
            {
              //左右滑动
              type: "inside",
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
            }
          ]
        }
        this.meteCharts();//加载折线图
      },

      /**
       * 清空折线图
       */
      setEmptyMeteOption() {
        this.meteOption = {};
        this.meteCharts();//加载折线图
      },

      /**
       * 折线图屏幕自适应
       */
      meteCharts(){
        document.getElementById("meteChart").removeAttribute("_echarts_instance_");
        let chartOption = this.$echarts.init(document.getElementById('meteChart'));
        chartOption.setOption(this.meteOption);
        //图表自适应
        window.addEventListener("resize",function(){
          chartOption.resize()  // myChart 是实例对象
        })
      },

      /**
       * 导出
       */
      meteExportData() {
        let that = this;
        if(that.meteTableData.length === 0) {
          that.$message({
            showClose: true,
            type: "warning",
            message: '未查询到数据',
            duration: 5000
          })
          return;
        }
        const {export_json_to_excel} = require('../../vendor/Export2Excel');
        const tHeader = ["名称", "时间", "值"];
        const filterVal = ['name', 'ts', 'value',];
        const list = that.meteTableData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.$t(this.defaultMeteAttr).split(',')[0] + "_历史数据");
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j=>v[j]))
      }
    }
  }
</script>


<style lang="less">
  @import "../less/MeteHistoryData";
</style>

<style>
  .meteHistory-data-content::-webkit-scrollbar {
    display: none;
  }

  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>





// WEBPACK FOOTER //
// src/components/view/MeteHistoryData.vue